import { render, staticRenderFns } from "./I2FormDateRange.vue?vue&type=template&id=5807d957"
import script from "./I2FormDateRange.vue?vue&type=script&lang=js"
export * from "./I2FormDateRange.vue?vue&type=script&lang=js"
import style0 from "./I2FormDateRange.vue?vue&type=style&index=0&id=5807d957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports